import React from "react";
import { api, type SessionUser } from "../api/client";

export function LoginButton({
  user,
  onLoggedOut,
}: {
  user: SessionUser | null;
  onLoggedOut: () => void;
}) {
  if (!user) {
    return (
      <a className="btn btn--discord" href={api.loginUrl()}>
        Se connecter avec Discord
      </a>
    );
  }

  const canWrite = user.role === "admin" || (user.isGuildMember && user.hasRequiredRole);

  return (
    <div className="user-badge">
      {user.avatarUrl && <img src={user.avatarUrl} alt="" className="user-badge__avatar" />}
      <span className="user-badge__name">{user.username}</span>
      {!canWrite && (
        <span className="user-badge__notice" title="Rejoins le serveur Discord de la communauté (et obtiens le rôle requis) pour pouvoir écrire des notes, traduire ou éditer.">
          lecture seule
        </span>
      )}
      <button
        className="btn btn--ghost"
        onClick={async () => {
          await api.logout();
          onLoggedOut();
        }}
      >
        Déconnexion
      </button>
    </div>
  );
}
